import React from 'react';
import { useEffect } from 'react';
import { post } from '../Auths/AuthToken';
import { useState } from 'react';
import setUiMessage from '../../Utilities/Tostify';
import ReactDatePicker from 'react-datepicker';
import { DEFAULT_DATE_FORMATE } from '../../constents';
import UploadFile from '../../Utilities/UploadFile';
import PopupHeadPatDetail from '../../Utilities/PopupHeadPatDetail';
import PatientSerchPopUpForApp from '../PatientSerchPopUpForApp';
import SelectServiceCode from '../../Utilities/SelectServiceCode';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Button from '../Button';
import ConfirmDialog from '../../Utilities/ConfirmDialog';
import { format } from 'date-fns';
import Select from 'react-select';

const getSelectedOption = (options, value) =>
  (options || []).find((o) => String(o.value) === String(value)) || null;

const buildOptions = (arr, valueKey, labelKey) =>
  (arr || []).map((item) => ({
    value: item?.[valueKey],
    label: item?.[labelKey],
  }));

function PriorAuthAddEditPopup({
  authId,
  patientId,
  handleClose,
  handleReload,
  fromPatProfile = false,
  fromMainAuth = false,
}) {
  const { user } = useSelector((state) => state.auth);
  const { selectedSerchPat } = useSelector((state) => state.patient);
  const [confirmActivePopup, setConfirmActivePopup] = useState(false);
  const [sucPrams, setSucPrams] = useState([]);

  const [allData, setAllData] = useState(null);
  const [patSerchPopup, setPatSerchPopup] = useState(!patientId);
  const [patId, setPatId] = useState(patientId || '');

  const [formData, setFormData] = useState({
    paior: '',
    validitystartdate: '',
    validityenddate: '',
    subscriberid: '',
    preorautnum: '',
    servicecode: '',
    servicecodeid: '',
    totalunit: '',
    servicedesc: '',
    authused: '',
    authstatus: '',
    refprovider: '',
    authdate: new Date(),
    renprovider: '',
    authattachment: [],
    authnotes: '',
    contactPerson: '',
    contactNo: '',
    mod1: '',
    mod2: '',
    mod3: '',
    mod4: '',
  });

  const formatDate = (date) => {
    if (!date) return '';
    const d = new Date(date);
    return isNaN(d.getTime()) ? '' : format(d, DEFAULT_DATE_FORMATE);
  };

  useEffect(() => {
    (async () => {
      try {
        const response = await post(
          'api/patient/ManagePriorAuth/openAuthorizationPopup',
          {
            patientId: patId,
            authId: authId,
          }
        );
        if (response.status === 200) {
          setAllData(response?.data);
          // setPriorAuthData(response?.data?.getAuthorization);

          if (response?.data?.getAuthorization) {
            setFormData((fd) => {
              return {
                ...fd,
                paior:
                  response?.data?.getAuthorization?.payer_id &&
                  response?.data?.getAuthorization?.payer_id,
                validitystartdate:
                  response?.data?.getAuthorization?.validity_from_date !==
                    '0000-00-00' &&
                  response?.data?.getAuthorization?.validity_from_date &&
                  new Date(
                    response?.data?.getAuthorization?.validity_from_date
                  ),
                validityenddate:
                  response?.data?.getAuthorization?.validity_to_date !==
                    '0000-00-00' &&
                  response?.data?.getAuthorization?.validity_to_date &&
                  new Date(response?.data?.getAuthorization?.validity_to_date),
                subscriberid:
                  response?.data?.getAuthorization?.subscriber_id &&
                  response?.data?.getAuthorization?.subscriber_id,
                preorautnum:
                  response?.data?.getAuthorization?.authorization_no &&
                  response?.data?.getAuthorization?.authorization_no,
                servicecode:
                  response?.data?.getAuthorization?.procedure_code &&
                  response?.data?.getAuthorization?.procedure_code,
                servicecodeid:
                  response?.data?.getAuthorization?.procedure_id &&
                  response?.data?.getAuthorization?.procedure_id,
                totalunit:
                  response?.data?.getAuthorization?.quantity &&
                  response?.data?.getAuthorization?.quantity,
                servicedesc:
                  response?.data?.getAuthorization?.procedure_name &&
                  response?.data?.getAuthorization?.procedure_name,
                authused:
                  response?.data?.getAuthorization?.used_quantity &&
                  response?.data?.getAuthorization?.used_quantity,
                authstatus:
                  response?.data?.getAuthorization?.status &&
                  response?.data?.getAuthorization?.status,
                refprovider:
                  response?.data?.getAuthorization?.referring_provider &&
                  response?.data?.getAuthorization?.referring_provider,
                authdate:
                  response?.data?.getAuthorization?.request_date !==
                    '0000-00-00' &&
                  response?.data?.getAuthorization?.request_date &&
                  new Date(response?.data?.getAuthorization?.request_date),
                renprovider:
                  response?.data?.getAuthorization?.rendering_provider &&
                  response?.data?.getAuthorization?.rendering_provider,
                authnotes:
                  response?.data?.getAuthorization?.note &&
                  response?.data?.getAuthorization?.note,
                contactPerson:
                  response?.data?.getAuthorization?.contact_person &&
                  response?.data?.getAuthorization?.contact_person,
                contactNo:
                  response?.data?.getAuthorization?.contact &&
                  response?.data?.getAuthorization?.contact,
                mod1: response?.data?.getAuthorization?.mod1,
                mod2: response?.data?.getAuthorization?.mod2,
                mod3: response?.data?.getAuthorization?.mod3,
                mod4: response?.data?.getAuthorization?.mod4,
              };
            });
          } else {
            if (response?.data?.defaultPayer) {
              setFormData((fd) => {
                return {
                  ...fd,
                  paior: response?.data?.defaultPayer || '',
                };
              });
            }
            if (response?.data?.subsId) {
              setFormData((fd) => {
                return {
                  ...fd,
                  subscriberid: response?.data?.subsId || '',
                };
              });
            }
          }
          if (response?.data?.allAttachArr) {
            setFormData((fd) => {
              return {
                ...fd,
                authattachment:
                  response?.data?.allAttachArr && response?.data?.allAttachArr,
              };
            });
          }
        }
      } catch (err) {
        setUiMessage('err', err?.message);
      }
    })();
  }, [patId, authId]);

  const handleFormSaveUpdate = async (authId = '') => {
    const obj = {
      authId: authId,
      patientId: patId,
      codeId: formData?.servicecodeid,
      code: formData?.servicecode,
      payerId: formData?.paior,
      subscriberId: formData?.subscriberid,
      contactPerson: formData?.contactPerson,
      contactNo: formData?.contactNo,
      requestDate: formatDate(formData?.authdate),
      vailidityFromDate: formatDate(formData?.validitystartdate),
      vailidityToDate: formatDate(formData?.validityenddate),
      referringProvider: formData?.refprovider,
      renderingProvider: formData?.renprovider,
      status: formData?.authstatus,
      authorizationNo: formData?.preorautnum,
      serviceDescription: formData?.servicedesc,
      totalUnit: formData?.totalunit,
      usedUnit: formData?.authused,
      note: formData?.authnotes,
      totFile: formData?.authattachment && formData?.authattachment.lngth,
      allAttach:
        formData?.authattachment &&
        formData?.authattachment
          .map((item, i) => {
            return !!item?.fileName ? item?.fileName + '|' + (i + 1) : '';
          })
          .join(','),
      loginUserId: user?.id,
      mod1: formData?.mod1,
      mod2: formData?.mod2,
      mod3: formData?.mod3,
      mod4: formData?.mod4,
    };

    if (
      !patId ||
      !formData?.paior ||
      !formData?.authstatus ||
      !formData?.servicecode
    ) {
      if (!patId) {
        setUiMessage('err', 'Please select Patient.');
      } else if (!formData?.paior) {
        setUiMessage('err', 'Please select Payor.');
      } else if (!formData?.servicecode) {
        setUiMessage('err', 'Please fill Service Code.');
      } else if (!formData?.authstatus) {
        setUiMessage('err', 'Please select Status.');
      }
    } else if (formData?.authstatus === '2' && !formData?.preorautnum) {
      setUiMessage('err', 'Please fill Prior Authorization no.');
    } else {
      try {
        const response = await post(
          'api/patient/ManagePriorAuth/saveAuth',
          obj
        );
        if (response.status === 200) {
          setUiMessage('suc', response?.data?.msg);
          if (response?.data?.activeStatus === '0') {
            setSucPrams([response?.data?.authId, patId]);
            setConfirmActivePopup(true);
          } else {
            handleReload();
            handleClose(false);
          }
        }
      } catch (err) {
        setUiMessage('err', err?.message);
      }
    }
  };

  const handleReturnFileArr = (fileArr) => {
    setFormData((fd) => {
      return {
        ...fd,
        authattachment: fileArr,
      };
    });
  };

  const handleAttachPatient = () => {
    setPatSerchPopup(true);
  };

  useEffect(() => {
    if (selectedSerchPat?.patId && !authId && !fromPatProfile) {
      setPatId(selectedSerchPat?.patId);
    }
  }, [selectedSerchPat?.patId, authId, fromPatProfile]);

  const handleServiceCode = (id, val, text, specificProId) => {
    setFormData({
      ...formData,
      servicecode: val,
      servicecodeid: specificProId,
      servicedesc: text,
    });
  };

  const handleSubsId = (payorId) => {
    let subsId =
      allData?.payerList &&
      allData?.payerList.find((item) => item.payer_provider_carrier === payorId)
        ?.identificationNumber;
    setFormData((fd) => {
      return {
        ...fd,
        subscriberid: subsId,
      };
    });
  };

  const handleConfirmPopup = async (parms) => {
    try {
      const response = await post(
        'api/patient/ManagePriorAuth/updateAuthStatus',
        {
          authId: parms[0],
          patientId: parms[1],
          loginUserId: user?.id,
        }
      );
      if (response?.data?.status === '1') {
        setUiMessage('suc', response?.data?.msg);
        handleReload();
      }
    } catch (error) {
      setUiMessage('err', error.message);
    }
  };

  return (
    <div className="modalBackground">
      <div className="insu-addedit-sec">
        <div className="">
          <div className="flex-sec white-bg justify-between item-center">
            {patId ? (
              <div className="flex-sec justify-between item-center clear-left15 width100">
                <PopupHeadPatDetail
                  patName={allData?.patName}
                  chartid={allData?.chart_number}
                  agestr={allData?.age}
                  gender={allData?.gender}
                  dob={allData?.dob}
                />
                {!authId && !fromPatProfile && (
                  <span className="clear-right10" onClick={handleAttachPatient}>
                    <Link>[Change patient]</Link>
                  </span>
                )}
              </div>
            ) : (
              <div className="hdr-pt-info flex-sec justify-end item-center width100">
                <Button variant="primary" onClick={handleAttachPatient}>
                  Attach patient
                </Button>
              </div>
            )}
            <Button variant="circle" onClick={handleClose}>
              X
            </Button>
          </div>
          <div className="insu-act-sec-bdy" style={{ height: '500px' }}>
            <div className="insu-act-sec-bdy-rw flex-sec">
              <div className="insu-act-sec-bdy-lft flex-sec">
                <span className="nsu-act-lbl">
                  Payor:<span className="required-fld">*</span>
                </span>
                <span className="nsu-act-val">
                  <Select
                    className="react-select-container"
                    classNamePrefix="react-select"
                    isClearable
                    placeholder="Select Payor"
                    options={buildOptions(
                      allData?.payerList,
                      'payer_provider_carrier',
                      'companyName'
                    )}
                    value={getSelectedOption(
                      buildOptions(
                        allData?.payerList,
                        'payer_provider_carrier',
                        'companyName'
                      ),
                      formData?.paior
                    )}
                    onChange={(opt) => {
                      const val = opt?.value ?? '';
                      setFormData({ ...formData, paior: val });
                      handleSubsId(val);
                    }}
                  />
                </span>
              </div>
              <div className="insu-act-sec-bdy-rt  flex-sec">
                <span className="nsu-act-lbl" style={{ width: '70px' }}>
                  Validity:
                </span>
                <span
                  className="nsu-act-val flex-sec"
                  style={{ gap: '8px', width: 'calc(100% - 85px)' }}
                >
                  <span
                    className="flex-sec pre-auth-validity"
                    style={{ flex: 1, minWidth: '145px' }}
                  >
                    <span className="nsu-act-lbl hide">Start:</span>
                    <span className="nsu-act-val" style={{ width: '100%' }}>
                      <ReactDatePicker
                        id="validitystartdate"
                        name="validitystartdate"
                        selected={formData?.validitystartdate || null}
                        onChange={(date) =>
                          setFormData({
                            ...formData,
                            validitystartdate: date,
                          })
                        }
                        className="inpt-width-nw"
                        dateFormat={DEFAULT_DATE_FORMATE}
                        placeholderText="From: mm-dd-yyyy"
                        maxDate={formData?.validityenddate || null}
                      />
                    </span>
                  </span>

                  <span
                    className="flex-sec pre-auth-validity"
                    style={{ flex: 1, minWidth: '145px' }}
                  >
                    <span className="nsu-act-lbl hide">End:</span>
                    <span className="nsu-act-val" style={{ width: '100%' }}>
                      <ReactDatePicker
                        id="validityenddate"
                        name="validityenddate"
                        selected={formData?.validityenddate || null}
                        onChange={(date) =>
                          setFormData({
                            ...formData,
                            validityenddate: date,
                          })
                        }
                        className="inpt-width-nw"
                        dateFormat={DEFAULT_DATE_FORMATE}
                        placeholderText="To: mm-dd-yyyy"
                        minDate={formData?.validitystartdate || null}
                      />
                    </span>
                  </span>
                </span>
              </div>
            </div>
            <div className="insu-act-sec-bdy-rw flex-sec alt-rw">
              <div className="insu-act-sec-bdy-lft flex-sec">
                <span className="nsu-act-lbl">Subscriber ID:</span>
                <span className="nsu-act-val">
                  <input
                    type="text"
                    className="inpt-width-nw"
                    placeholder="Document name"
                    id="subscriberid"
                    name="subscriberid"
                    value={formData?.subscriberid || ''}
                    onChange={(e) =>
                      setFormData({ ...formData, subscriberid: e.target.value })
                    }
                  />
                </span>
              </div>
              <div className="insu-act-sec-bdy-rt  flex-sec">
                <span className="nsu-act-lbl">Prior Authorization#:</span>
                <span className="nsu-act-val">
                  <input
                    type="text"
                    className="inpt-width-nw"
                    placeholder="write the number here..."
                    id="preorautnum"
                    name="preorautnum"
                    value={formData?.preorautnum || ''}
                    maxLength={10}
                    onChange={(e) =>
                      setFormData({ ...formData, preorautnum: e.target.value })
                    }
                  />
                </span>
              </div>
            </div>
            <div className="insu-act-sec-bdy-rw flex-sec">
              {formData?.servicecode ? (
                <SelectServiceCode
                  serviceCode={formData?.servicecode}
                  patId={patId}
                  returnData={handleServiceCode}
                />
              ) : (
                <SelectServiceCode
                  serviceCode={formData?.servicecode}
                  patId={patId}
                  returnData={handleServiceCode}
                />
              )}
              <div className="insu-act-sec-bdy-rt  flex-sec">
                <span className="nsu-act-lbl">Total Unit:</span>
                <span className="nsu-act-val">
                  <input
                    type="text"
                    className="inpt-width-nw"
                    placeholder="Put the unit here..."
                    id="totalunit"
                    name="totalunit"
                    value={formData?.totalunit || ''}
                    onChange={(e) =>
                      setFormData({ ...formData, totalunit: e.target.value })
                    }
                  />
                </span>
              </div>
            </div>
            <div className="insu-act-sec-bdy-rw flex-sec">
              <span className="nsu-act-lbl">Modifier:</span>
              <span
                className="nsu-act-val"
                style={{
                  display: 'grid',
                  gridTemplateColumns: 'repeat(2, max-content)',
                  gap: '12px 65px',
                }}
              >
                {['mod1', 'mod2', 'mod3', 'mod4'].map((key) => {
                  const modOptions = buildOptions(
                    allData?.modifiersDropArray,
                    'value',
                    'title'
                  );
                  const selectedMods = ['mod1', 'mod2', 'mod3', 'mod4']
                    .map((k) => formData[k])
                    .filter(Boolean);

                  return (
                    <div
                      key={key}
                      className="flex-sec item-center"
                      style={{ gap: '6px' }}
                    >
                      <span style={{ flexShrink: 0 }}>
                        {`M${key.replace('mod', '')}`}:
                      </span>
                      <Select
                        className="react-select-container"
                        classNamePrefix="react-select"
                        isClearable
                        placeholder="Select"
                        options={modOptions}
                        value={getSelectedOption(modOptions, formData[key])}
                        isOptionDisabled={(opt) =>
                          selectedMods.includes(opt.value) &&
                          formData[key] !== opt.value
                        }
                        onChange={(opt) =>
                          setFormData({
                            ...formData,
                            [key]: opt?.value ?? '',
                          })
                        }
                        styles={{
                          container: (base) => ({
                            ...base,
                            width: '220px',
                            minWidth: '215px',
                            maxWidth: '215px',
                          }),
                        }}
                      />
                    </div>
                  );
                })}
              </span>
            </div>
            <div className="insu-act-sec-bdy-rw flex-sec alt-rw">
              <div className="insu-act-sec-bdy-lft flex-sec">
                <span className="nsu-act-lbl">Service Description:</span>
                <span className="nsu-act-val">
                  <input
                    type="text"
                    className="inpt-width-nw"
                    placeholder="Write the description here..."
                    id="servicedesc"
                    name="servicedesc"
                    value={formData?.servicedesc || ''}
                    onChange={(e) =>
                      setFormData({ ...formData, servicedesc: e.target.value })
                    }
                  />
                </span>
              </div>
              <div className="insu-act-sec-bdy-rt  flex-sec">
                <span className="nsu-act-lbl">Used</span>
                <span className="nsu-act-val">
                  <input
                    type="text"
                    className="inpt-width-nw"
                    placeholder="You can write here.."
                    id="authused"
                    name="authused"
                    value={formData?.authused || ''}
                    onChange={(e) =>
                      setFormData({ ...formData, authused: e.target.value })
                    }
                  />
                </span>
              </div>
            </div>
            <div className="insu-act-sec-bdy-rw flex-sec">
              <div className="insu-act-sec-bdy-lft flex-sec">
                <span className="nsu-act-lbl">
                  Status:<span className="required-fld">*</span>
                </span>
                <span className="nsu-act-val">
                  <Select
                    className="react-select-container"
                    classNamePrefix="react-select"
                    isClearable
                    placeholder="Select status"
                    options={buildOptions(allData?.status, 'id', 'val')}
                    value={getSelectedOption(
                      buildOptions(allData?.status, 'id', 'val'),
                      formData?.authstatus
                    )}
                    onChange={(opt) =>
                      setFormData({
                        ...formData,
                        authstatus: opt?.value ?? '',
                      })
                    }
                  />
                </span>
              </div>
              <div className="insu-act-sec-bdy-rt  flex-sec">
                <span className="nsu-act-lbl">Ref. Provider:</span>
                <span className="nsu-act-val">
                  <Select
                    className="react-select-container"
                    classNamePrefix="react-select"
                    isClearable
                    placeholder="Select Provider"
                    options={buildOptions(
                      allData?.referringDrList,
                      'id',
                      'refName'
                    )}
                    value={getSelectedOption(
                      buildOptions(
                        allData?.referringDrList,
                        'id',
                        'refName'
                      ),
                      formData?.refprovider
                    )}
                    onChange={(opt) =>
                      setFormData({
                        ...formData,
                        refprovider: opt?.value ?? '',
                      })
                    }
                  />
                </span>
              </div>
            </div>
            <div className="insu-act-sec-bdy-rw flex-sec alt-rw">
              <div className="insu-act-sec-bdy-lft flex-sec">
                <span className="nsu-act-lbl">Date:</span>
                <span className="nsu-act-val">
                  <ReactDatePicker
                    id="authdate"
                    name="authdate"
                    selected={formData?.authdate || null}
                    onChange={(date) =>
                      setFormData({
                        ...formData,
                        authdate: date,
                      })
                    }
                    className="inpt-width-nw"
                    dateFormat={DEFAULT_DATE_FORMATE}
                    placeholderText="mm-dd-yyyy"
                  />
                </span>
              </div>
              <div className="insu-act-sec-bdy-rt  flex-sec">
                <span className="nsu-act-lbl">Rend. Provider:</span>
                <span className="nsu-act-val">
                  <Select
                    className="react-select-container"
                    classNamePrefix="react-select"
                    isClearable
                    placeholder="Select Provider"
                    options={buildOptions(
                      allData?.allRenderList,
                      'id',
                      'renderName'
                    )}
                    value={getSelectedOption(
                      buildOptions(
                        allData?.allRenderList,
                        'id',
                        'renderName'
                      ),
                      formData?.renprovider
                    )}
                    onChange={(opt) =>
                      setFormData({
                        ...formData,
                        renprovider: opt?.value ?? '',
                      })
                    }
                  />
                </span>
              </div>
            </div>
            <div className="insu-act-sec-bdy-rw flex-sec">
              <div className="insu-act-sec-bdy-lft flex-sec">
                <span className="nsu-act-lbl">Contact Person:</span>
                <span className="nsu-act-val">
                  <input
                    type="text"
                    className="inpt-width-nw"
                    placeholder="Write the contact person's name here..."
                    id="contactPerson"
                    name="contactPerson"
                    value={formData?.contactPerson || ''}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        contactPerson: e.target.value,
                      })
                    }
                  />
                </span>
              </div>
              <div className="insu-act-sec-bdy-rt  flex-sec">
                <span className="nsu-act-lbl">Contact#:</span>
                <span className="nsu-act-val">
                  <input
                    type="text"
                    className="inpt-width-nw"
                    placeholder="Write the contact no. here..."
                    id="contactNo"
                    name="contactNo"
                    value={formData?.contactNo || ''}
                    onChange={(e) =>
                      setFormData({ ...formData, contactNo: e.target.value })
                    }
                    maxLength={10}
                  />
                </span>
              </div>
            </div>
            <div className="insu-act-sec-bdy-rw flex-sec alt-rw">
              <UploadFile
                fileArr={formData?.authattachment}
                handleReturnFileArr={handleReturnFileArr}
              />
              <div className="insu-act-sec-bdy-rt  flex-sec">
                <span className="nsu-act-lbl">Notes</span>
                <span className="nsu-act-val">
                  <textarea
                    type="text"
                    className="inpt-width-nw"
                    placeholder="You can write here.."
                    style={{ height: '74px' }}
                    id="authnotes"
                    name="authnotes"
                    value={formData?.authnotes || ''}
                    onChange={(e) =>
                      setFormData({ ...formData, authnotes: e.target.value })
                    }
                  ></textarea>
                </span>
              </div>
            </div>
          </div>
          <div
            className="flex-sec justify-end gap10"
            style={{ padding: '5px 15px' }}
          >
            <Button variant="outline" onClick={handleClose}>
              Cancel
            </Button>
            <Button
              variant="primary"
              onClick={() => handleFormSaveUpdate(authId)}
            >
              {authId ? 'Update' : 'Save'}
            </Button>
          </div>
        </div>
      </div>
      {patSerchPopup && (
        <PatientSerchPopUpForApp
          handleClosePatSerch={() => setPatSerchPopup(false)}
        />
      )}
      {confirmActivePopup && (
        <ConfirmDialog
          title={'Authorization status'}
          bodytext={`More than one authorization exists. Make this one active?`}
          closeDialog={() => {
            setConfirmActivePopup(false);
            handleClose(false);
            handleReload();
          }}
          successDialog={handleConfirmPopup}
          sucPrams={sucPrams}
        />
      )}
    </div>
  );
}

export default PriorAuthAddEditPopup;
